export enum UserType {
  Unknown = 0,
  Ofqual = 1,
  CCEA = 2,
  AO = 3,
}
